export enum CheckInStatusEnum {
  ToApprove = 0,
  Approved = 1,
  Rejected = 2,
  OnHold = 3,
  CommercialBlocked = 4,
}